<template>
  <div id="app" class="app-content">
    <van-popup v-model="isWx"
      class="overlay-bg"
      position="bottom"
      :style="{ height: '100%' }">
      <van-image
          :src="downBg"
          fit="contain"
        />
       <div class="app-url">
        <van-cell-group inset>
          <van-field
            v-model="url"
            rows="1"
            autosize
            label="网址"
            type="textarea"
          />
        </van-cell-group>
        <van-button type="primary" block @click="copyUrl">复制</van-button>
       </div>

    </van-popup>
    <router-view></router-view>
    <Tabbar v-show="isShowBar"/>
  </div>
</template>
<script>

import Tabbar from "./views/Tabbar.vue";

export default {
  name: 'App',
  data() {
    return {
        isShowBar: true,
        isWx: false,
        downBg: "https://new.jingzong.org/static/jingzong_v2/image/browser.jpg",
        url:'2222',
    };
  },
  components: {
    Tabbar
  },
  beforeCreate(){
    const domain = window.location.host;
    if(this.$tools.IsWeixinOrAlipay()==13 && domain=='m.jingzong.vip'){
      this.isWx = true
    }


    if(domain=='m.jingzong.net'){
        window.location.href = "https://h5.jingzong.net"+window.location.pathname;
    }
    if(domain=='m.jingzong.org'){
        window.location.href = "https://h5.jingzong.net"+window.location.pathname;
    }
  },
  mounted () {
    this.url = window.location

    // this.$dialog.alert({
    //   title:'请保存并使用新地址',
    //   message: '<p><br/><a href="https://h5.jingzong.net">https://h5.jingzong.net</a><br/><br/>旧地址于10月1日停止使用，感恩您！</p>',
    //   allowHtml:true,
    //   confirmButtonText:'复制并关闭'
    // }).then(() => {
    //   this.$copyText('https://h5.jingzong.net').then(function (e) {
    //     console.log(e)
    //   }, function (e) {
    //     console.log(e)
    //   })
    // });
  },
  created() {
    console.log(this.$route.name);
    if(this.$route.name == 'SLive' 
    || this.$route.name == 'SDownload' 
    || this.$route.name == 'Birthday' 
    || this.$route.name == 'SLiveVt'
    || this.$route.name == 'Special'
    || this.$route.name == 'Redirect'
    || this.$route.name == 'Ciguang'
    || this.$route.name == 'Daoying'){
      this.isShowBar = false;
    }
  },
  methods: {
    copyUrl(){
      /* 复制内容到文本域 */
      navigator.clipboard.writeText(this.url);
    }
  },
  metaInfo: {
      title: '澳洲淨宗學院',
      meta: [
        { charset: 'utf-8' },
        { name: 'viewport', content: 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0' }
      ]
  }
}
</script>
<style  scoped>
.app-content {
    max-width: 600px;
    margin-left: auto;
    margin-right: auto;
}
.overlay-bg{
  background-color: #2e2e2e;
}
.app-url{
 padding: 20px;
}
.v-list{
  margin: 20px 10px 80px 10px;
}
.v-item{
  margin-bottom: 10px;
}
.v-item-desc{
  margin: 5px 0px;
}
.v-item-title{
  font-size: 14px;
  line-height: 30px;
  padding-right: 5px;
  color: #323233;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.v-item-date{
  font-size: 12px;
  color: #969799;
}
.v-item-img{
  width: 100%;
  height:95px;
    object-fit: cover;
}


</style>
